import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Compara duas pessoas por id (tolerante a string/number e a valores ausentes).
 * Retorna false se qualquer um dos lados não tiver id.
 */
export function isSamePessoa(
  a?: { id?: number | string | null } | null,
  b?: { id?: number | string | null } | null,
): boolean {
  if (a?.id == null || b?.id == null) return false;
  return Number(a.id) === Number(b.id);
}
